var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ScoreSlider from './ScoreSlider';
import { useAiReportStore } from "../../../../store/ai-report/global-store";
import { Box, Typography } from 'fbm-ui';
import update from 'immutability-helper';
import { useCallback } from 'react';
var Abilities = function (_a) {
    var stepIndex = _a.stepIndex, disabledScore = _a.disabledScore;
    var _b = useAiReportStore(function (store) { return [store.reportResult]; }), reportResult = _b.reportResult, updateReportResult = _b.updateReportResult, onScoreChange = _b.onScoreChange;
    var steps = (reportResult || {}).steps;
    var handleChangeCommitted = useCallback(function (score, index, type) {
        var _a, _b;
        if (disabledScore)
            return;
        var newSteps = update(steps, (_a = {}, _a[stepIndex] = { scoreInfo: { abilities: (_b = {}, _b[index] = { finalScore: { $set: score } }, _b) } }, _a));
        updateReportResult(__assign(__assign({}, reportResult), { steps: newSteps }));
        onScoreChange &&
            onScoreChange({
                flowStepToken: steps ? steps[stepIndex].token : '',
                aiAbilityChangeType: steps && steps[stepIndex].scoreInfo.abilities[index].type,
                type: 2,
                score: score,
            });
    }, [stepIndex, reportResult, steps, updateReportResult, onScoreChange, disabledScore]);
    return (_jsxs(Box, __assign({ mt: 1 }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "secondary", mb: 1 }, { children: "\u5206\u503C\u8BA1\u7B97\u89C4\u5219\uFF1A\u7EFC\u5408\u8BC4\u5206=AI\u8BC4\u5206*\u5355\u9898\u6743\u91CD" })), _jsx(Box, __assign({ mt: 3 }, { children: steps &&
                    steps[stepIndex].scoreInfo.abilities.map(function (_a, index) {
                        var name = _a.name, originScore = _a.originScore, finalScore = _a.finalScore;
                        return (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body2" }, { children: name })), _jsx(ScoreSlider, { width: 604, disabledScore: disabledScore, isShowLabel: true, originScore: originScore, finalScore: finalScore, valueLabelDisplay: "".concat(disabledScore ? 'off' : 'auto'), onChangeCommitted: function (score) { return handleChangeCommitted(score, index, 'ability'); } })] }, name));
                    }) }))] })));
};
export default Abilities;
